import { render, staticRenderFns } from "./account-transcription-settings.vue?vue&type=template&id=860f63e4&scoped=true"
import script from "./account-transcription-settings.vue?vue&type=script&lang=js"
export * from "./account-transcription-settings.vue?vue&type=script&lang=js"
import style0 from "./account-transcription-settings.vue?vue&type=style&index=0&id=860f63e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "860f63e4",
  null
  
)

export default component.exports